import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedMessage, FormattedTime} from "react-intl";
import moment from 'moment';
import Duration from "components/Duration";
import RelativeDuration from "components/RelativeDuration";
import {Button} from 'reactstrap';
import IconSvg from "components/IconSvg";
import {formatPhone} from "helpers/phone";

class ChatItem extends React.Component {
    static propTypes = {
        contact: PropTypes.shape({
            type: PropTypes.string.isRequired,
            timeCreated: PropTypes.number.isRequired,
            directionReceived: PropTypes.bool,
            profile: PropTypes.shape({
                advert: PropTypes.shape({
                    name: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
            voice: PropTypes.shape({
                note: PropTypes.string,
                timeStarted: PropTypes.number,
                timeFinished: PropTypes.number,
                state: PropTypes.string.isRequired,
            }),
            text: PropTypes.shape({
                message: PropTypes.string,
            })
        }).isRequired,
        onSaveNote: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.onNoteTextChange = this.onNoteTextChange.bind(this);
        this.saveNote = this.saveNote.bind(this);
    }

    componentWillMount() {
        this.setState({
            note: ''
        });
    }

    onNoteTextChange(event) {
        const value = event.target.value;
        this.setState({
            note: value
        });
    }

    saveNote() {
        this.props.onSaveNote(this.state.note);
    }

    render() {
        const {contact} = this.props;

        const isNew = contact.type === 'voice' && contact.voice.note === null && ['UP', 'FINISHED'].includes(contact.voice.state);
        const text = contact.type === 'voice' ? contact.voice.note : contact.text.message;

        return (
            <div
                className={"chat__item " + (isNew ? "chat__item--new" : (!contact.directionReceived ? "chat__item--in" : "chat__item--out"))}>
                {!contact.directionReceived &&
                <div className="chat__item--space"/>
                }
                <div className="chat__item--content">
                <span className="chat__time">
                    <FormattedDate value={moment.unix(contact.timeCreated)}/> <FormattedTime
                    value={moment.unix(contact.timeCreated)}/>
                </span>
                    <div className="chat__text">
                        <strong className={"chat__title" + (contact.type === 'voice' ? ' chat__title--phone' : '')}>
                            {contact.type === 'voice' &&
                            <IconSvg id='phone'/>
                            }
                            <span>
                        {!contact.directionReceived && contact.profile.advert.name}

                                {contact.directionReceived && formatPhone(contact.customerPhonenum)}
                        </span>
                            {contact.type === 'voice' &&
                            <span className="chat__title--status">
                                {contact.voice.state === 'RINGING' &&
                                <FormattedMessage id="conversation.ringing" defaultMessage="Ringing"/>
                                }

                                {contact.voice.state === 'CREATED' &&
                                <FormattedMessage id="conversation.unconnected" defaultMessage="Unconnected"/>
                                }

                                {contact.voice.state === 'MISSED' &&
                                <FormattedMessage id="conversation.unconnected" defaultMessage="Unconnected"/>
                                }

                                {contact.voice.state === 'FINISHED' &&
                                <Duration
                                    showBrackets
                                    duration={moment.unix(contact.voice.timeFinished).diff(moment.unix(contact.voice.timeStarted), 'seconds')}/>
                                }

                                {contact.voice.state === 'UP' &&
                                <RelativeDuration date={moment.unix(contact.voice.timeStarted)}/>
                                }
                            </span>
                            }
                        </strong>
                        {!isNew && text}

                        {isNew &&
                        <div className="form-group">
                            <FormattedMessage id="conversation.modal.placeholder" defaultMessage="Call description"
                                              children={(message) => (
                                                  <textarea onChange={this.onNoteTextChange} className="form-control"
                                                            placeholder={message}/>
                                              )}
                            />
                        </div>
                        }

                        {isNew &&
                        <div className="text-right">
                            <Button className="btn-clickable" onClick={this.saveNote}>
                                <FormattedMessage id="conversation.modal.submit" defaultMessage="Submit"/>
                            </Button>
                        </div>
                        }
                    </div>
                </div>
                {contact.directionReceived &&
                <div className="chat__item--space"/>
                }
            </div>
        )
    }
}

export default ChatItem;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Conversation/ChatItem.jsx